import {useEffect, useState} from 'react';

import type {SectionWithMetadata} from '../types';

function usePinnedSections(
  visibleSectionsWithRefs: SectionWithMetadata[]
): string[] {
  const [pinnedSections, setPinnedSections] = useState<string[]>(
    visibleSectionsWithRefs.filter(s => s.pinned).map(s => s.ref.id)
  );

  const [newPinnedSections, setNewPinnedSections] = useState<string[]>([]);

  /*
   * if we need to test the performance of this hook we can create a test like this:
   * https://github.com/wandb/core/pull/17704/commits/7e8f6f252fe946241ee564c79206a09be224835f
   */
  useEffect(() => {
    for (const updatedSectionConfig of visibleSectionsWithRefs) {
      if (
        updatedSectionConfig.pinned &&
        !pinnedSections.includes(updatedSectionConfig.ref.id)
      ) {
        setNewPinnedSections(prev => [...prev, updatedSectionConfig.ref.id]);
        setPinnedSections(prev => [...prev, updatedSectionConfig.ref.id]);
        continue;
      }

      if (
        !updatedSectionConfig.pinned &&
        pinnedSections.includes(updatedSectionConfig.ref.id)
      ) {
        setPinnedSections(prev =>
          prev.filter(id => id !== updatedSectionConfig.ref.id)
        );
      }
    }

    const timer = setTimeout(() => {
      setNewPinnedSections([]);
    }, 800);

    return () => clearTimeout(timer);
    // we don't want the pinnedSections array as a dependency because
    // it's storing the previous "snapshot" of which sections were pinned
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleSectionsWithRefs]);

  return newPinnedSections;
}

export default usePinnedSections;
